import React, { forwardRef } from 'react';
import { styled, ButtonBase } from '@mui/material';

import Avatar from 'shell/components/Avatar';
import Box from 'shell/components/Box';

const CustomButtonBase = styled(ButtonBase)(({ theme }) => {
    return {
        position: 'relative',
        borderRadius: '50%',
        '&:focus-visible': {
            outline: `${theme.palette.ensightful.secondary[100]} solid 3px`,
            '& > .MuiAvatar-root': {
                filter: 'brightness(0.85)',
            },
        },
        '&:hover': {
            '& > .MuiAvatar-root': {
                filter: 'brightness(0.85)',
            },
        },
        '&:active': {
            '& > .MuiAvatar-root': {
                filter: 'brightness(0.75)',
            },
        },
    };
});

const CustomBox = styled(Box)(({ selected, theme }) => {
    return {
        position: 'absolute',
        borderRadius: '50%',
        width: 'calc(100% - 2px)',
        height: 'calc(100% - 2px)',
        background: 'transparent',
        border: `2px solid ${theme.palette.ensightful.shades[0]}`,
        ...(!selected && {
            display: 'none',
        }),
    };
});

export default forwardRef(({ selected, value, onClick, ...rest }, ref) => {
    return (
        <CustomButtonBase selected={selected} onClick={() => onClick(value)}>
            <Avatar ref={ref} {...rest} />
            <CustomBox selected={selected} />
        </CustomButtonBase>
    );
});
